import type { RouteObject } from 'react-router';

export const landingRoutes: RouteObject[] = [
  { index: true, lazy: () => import('./pages/HomePage').then((m) => ({ Component: m.HomePage })) },
];
